import { Calculator, Clapperboard, Headset, Megaphone, Settings, ShieldAlert } from 'lucide-react';
/** Единственный источник истины по составу и порядку пространств. */
export const ADMIN_WORKSPACES = [
    { id: 'support', label: 'Поддержка', icon: Headset, order: 10 },
    { id: 'risk', label: 'Платежи и риски', icon: ShieldAlert, order: 20 },
    // Контент-движок (публикации роликов в соцсети). «Система» остаётся
    // последней: туда ходят реже всего.
    { id: 'content', label: 'Контент', icon: Clapperboard, order: 25 },
    // Реклама (auto-ads): конструктор запусков FB, а дальше — правила, скейл,
    // аналитика окупаемости, переносимые из старой админки. Каждая функция —
    // отдельный отсоединяемый `admin-module-ads-*` внутри этого пространства.
    { id: 'ads', label: 'Реклама', icon: Megaphone, order: 26 },
    // Квартальный НДС (ЕС OSS + Великобритания). Отдельное пространство, а не
    // «Платежи и риски»: там — разбор отдельных клиентов и чарджбеков, здесь —
    // отчётность компании раз в квартал, и круг людей другой (`accounting.read`).
    { id: 'accounting', label: 'Бухгалтерия', icon: Calculator, order: 27 },
    { id: 'system', label: 'Система', icon: Settings, order: 30 },
];
/**
 * Индекс по id. Аннотация `Record<AdminWorkspaceId, AdminWorkspace>` — это и
 * есть проверка полноты: новый член union'а без строки в `ADMIN_WORKSPACES`
 * ломает компиляцию здесь, а не отдаёт `undefined` в шапке сайдбара.
 */
export const ADMIN_WORKSPACE_BY_ID = Object.fromEntries(ADMIN_WORKSPACES.map((w) => [w.id, w]));
/** Куда приземляется оператор, у которого нет сохранённого выбора. */
export const DEFAULT_WORKSPACE_ID = 'support';
/** Валидатор для значения, пришедшего из localStorage (произвольная строка). */
export function isAdminWorkspaceId(v) {
    return Object.prototype.hasOwnProperty.call(ADMIN_WORKSPACE_BY_ID, v);
}
//# sourceMappingURL=workspaces.js.map